import React,{useState,useEffect,}from 'react'
import { Table,Space,Flex} from 'antd';
import { useGoodsListQuery, } from '../../store/ReactWebSiteApi';
import GoodsAdd from './GoodsAdd';
import GoodsEdit from './GoodsEdit';
import GoodsSpecList from './GoodsSpecList';
import Main from '../../cpn/Main';
import {DeleteOutlined,LogoutOutlined} from '@ant-design/icons';
import GoodsQuery from './GoodsQuery';
import GoodsDel from './GoodsDel';
function GoodsList() {
    const [query,setQuery] = useState({
        eg_e_id:localStorage.getItem('e_id'),
        eg_state:'2'
    })   
    const {data,isSuccess} = useGoodsListQuery(query,{refetchOnMountOrArgChange:1})
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eg_id:key,ed_name,eg_name,eg_content,eg_uname,eg_ctime,eg_update_ctime,eg_update_uname,ec_name,eg_image_file,eg_egt_name,eg_state} = item;
                    return item = {key,ed_name,eg_name,eg_content,eg_uname,eg_ctime,eg_update_ctime,eg_update_uname,ec_name,eg_image_file,eg_egt_name,eg_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eg_ctime;
                    let bTimeString = b.eg_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'eg_name',
            title: '产品名称',
            dataIndex: 'eg_name',
            width:"20%"
        },     
        {
            key: 'eg_egt_name',
            title: '产品类型',
            dataIndex: 'eg_egt_name',
            width:"20%"
        },            
        {
            key: 'ed_name',
            title: '部门',
            dataIndex: 'ed_name',
            width:"20%"
        },            
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },               
        // {
        //     key: 'time',
        //     title: '操作记录',
        //     render: (_,record) => {
        //         return <>
        //             <div>新建时间：{record.eg_ctime + record.eg_uname}</div>
        //             <div>修改时间：{record.eg_update_ctime + record.eg_update_uname}</div>
        //         </>
        //     }
        // },
        {
            key: 'action',
            width:"20%",
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space size='middle'>    
                        <GoodsEdit 
                            eg_id={record.key}
                            eg_state={record.eg_state}
                        />
                        <GoodsDel
                            eg_id={record.key}
                            eg_state={record.eg_state}
                            eg_name={record.eg_name}
                        />
                        {/* <a onClick={() => {navi(`/OtaGoodsProfit?esv_id=22&id=${record.key}&name=${record.eg_name}`)}}>利润</a> */}
                        <GoodsSpecList goodsName={record.eg_name} egg_eg_id={record.key}/>
                    </Space>
                   
                </>
            }
        },
    ]
    
    return (
        <Main t1='产品'>
            {query.eg_state==='2' ? <Flex justify='space-between' align='center'>
                <Space>
                    <GoodsAdd/>
                    <GoodsQuery
                        getGoodsQuery={(e) => {
                            setQuery(prevState=>({
                                ...prevState,
                                eg_name:e.eg_name,
                                eg_dept_id:e.eg_dept_id,
                                eg_egt_id:e.eg_egt_id,
                            }))
                        }}
                    />
                </Space>
                <a 
                    style={{
                        marginRight:"20px",
                        fontSize:"18px"
                    }}
                    onClick={() => {
                        setQuery(prevState=>({...prevState,eg_state:'1'}))
                    }}
                ><DeleteOutlined /> 已删除产品</a>
            </Flex>:<Flex>
                <a 
                    style={{
                        fontSize:"18px"
                        }}
                    onClick={() => {
                        setQuery(prevState=>({...prevState,eg_state:'2'}))
                    }}
                ><LogoutOutlined /> 未删除产品</a>
                </Flex>
            }
            <Table 
                columns={columns} 
                dataSource={list} 
                style={{marginTop:"20px"}}
                pagination={{showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,}}
            /> 
        </Main>
    )
}

export default GoodsList